module.exports = __webpack_public_path__ + "static/media/step2-back.d8cfdf09.png";